import type { EnvironmentConnectionPresentation } from "../connection/presentation.ts";

/** Files are read through the runtime, so they can be read while it is connected. */
export function resolveFilesystemReadAccess(input: {
  readonly isCatalogReady: boolean;
  readonly connection: Pick<EnvironmentConnectionPresentation, "phase" | "error"> | null;
}) {
  if (input.connection?.phase === "connected") {
    return { canReadFiles: true, isPending: false, error: null };
  }
  // Wait for the catalog before interpreting a missing presentation as disconnected.
  const isPending =
    !input.isCatalogReady ||
    input.connection?.phase === "connecting" ||
    input.connection?.phase === "reconnecting";
  return {
    canReadFiles: false,
    isPending,
    error: isPending ? null : (input.connection?.error ?? "This environment is not connected."),
  };
}
